import {
  GET_NAVIGATION_SIDEBAR,
  GET_NAVIGATION_SIDEBAR_SUCCESS,
  GET_NAVIGATION_SIDEBAR_FAIL,
} from "./actionTypes"

export const getNavigationSidebar = roleTypeId => ({
  type: GET_NAVIGATION_SIDEBAR,
  payload: roleTypeId,
})

export const getNavigationSidebarSuccess = navigations => ({
  type: GET_NAVIGATION_SIDEBAR_SUCCESS,
  payload: navigations,
})

export const getNavigationSidebarFail = error => ({
  type: GET_NAVIGATION_SIDEBAR_FAIL,
  payload: error,
})
